// extracted by mini-css-extract-plugin
export default {"menuOpen":"Options_menuOpen__jGVOE","optionDisabled":"Options_optionDisabled__MM5JU"};